<template>
  <v-dialog
    :value="value"
    persistent
    max-width="400"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title class="headline tourist-tax-pro-red--text">
        {{ title }}
      </v-card-title>
      <v-card-text>
        <slot></slot>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#0f0f0f"
          text
          :disabled="loading"
          @click="$emit('input', false)"
        >
          {{ cancelText }}
        </v-btn>
        <v-btn
          color="#e61e30"
          text
          :loading="loading"
          :disabled="loading"
          @click="$emit('confirm')"
        >
          {{ confirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ConfirmDialog",

  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: "Conferma"
    },
    confirmText: {
      type: String,
      default: "Conferma"
    },
    cancelText: {
      type: String,
      default: "Annulla"
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
};
</script>
